<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLongTitle">Integrations</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div id="accordion">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button class="btn" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                aria-controls="collapseOne">
                <p class="btn-text">Hubspot</p>
              </button>
            </h5>
          </div>

          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="card-body">
              <h6>Hubspot Integration</h6>
              <p>To setup this integration you must setup a private app in Hubspot. The private app and needs the
                following scopes:</p>
              <ul>
                <li>crm.objects.contacts.read</li>
                <li>crm.objects.deal.read</li>
                <li>crm.objects.companies.read</li>
                <li>crm.objects.owners.read</li>
                <li>conversations.read</li>
              </ul>
              <p>When the app is created api key should be entered in the api key field below.</p>
              <p>To complete the setup you should add a webhook to the private app with a trigger on dealstage change
                and the following url:</p>
              <p><b>https://bsd16jxdfa.execute-api.eu-central-1.amazonaws.com/Prod/hubspot/{{orgid}}</b></p>
              <p>You can use the 3 key-value sets to filter what deals should be created</p>

              <form>
                <div class="form-group">
                  <p class="mb-0">API Key</p>
                  <input (keyup)="saveIntegrationsettings()" type="string" name="apikey" class="form-control"
                    id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter API Key..."
                    [(ngModel)]="integrationsetting.hubSpotKey">
                  <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                </div>
                <h6>Filters</h6>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Filter Key 1</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filterfield1" class="form-control"
                      id="filterfield1" aria-describedby="emailHelp" placeholder="Enter field for filtering..."
                      [(ngModel)]="integrationsetting.filterfield1">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Filter Value 1</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filtervalue1" class="form-control"
                      id="filtervalue1" aria-describedby="emailHelp"
                      placeholder="Enter values for filtering separated by | (pipe)"
                      [(ngModel)]="integrationsetting.filtervalue1">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Filter Key 2</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filterfield2" class="form-control"
                      id="filterfield2" aria-describedby="emailHelp" placeholder="Enter field for filtering..."
                      [(ngModel)]="integrationsetting.filterfield2">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Filter Value 2</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filtervalue2" class="form-control"
                      id="filtervalue2" aria-describedby="emailHelp"
                      placeholder="Enter values for filtering separated by | (pipe)"
                      [(ngModel)]="integrationsetting.filtervalue2">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Filter Key 3</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filterfield3" class="form-control"
                      id="filterfield3" aria-describedby="emailHelp" placeholder="Enter field for filtering..."
                      [(ngModel)]="integrationsetting.filterfield3">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Filter Value 3</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="filtervalue3" class="form-control"
                      id="filtervalue3" aria-describedby="emailHelp"
                      placeholder="Enter values for filtering separated by | (pipe)"
                      [(ngModel)]="integrationsetting.filtervalue3">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <h6>Add custom properties</h6>
                <p>Use the following fields to add custom properties to the deal</p>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Property Key 1</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="propertyfield1" class="form-control"
                      id="filterfield1" aria-describedby="emailHelp" placeholder="Enter property name"
                      [(ngModel)]="integrationsetting.propertyfield1">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Property Value 1</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="Propertyvalue1" class="form-control"
                      id="Propertyvalue1" aria-describedby="emailHelp" placeholder="Enter property code"
                      [(ngModel)]="integrationsetting.propertyvalue1">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Property Key 2</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="Propertyfield2" class="form-control"
                      id="Propertyfield2" aria-describedby="emailHelp" placeholder="Enter property name"
                      [(ngModel)]="integrationsetting.propertyfield2">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Property Value 2</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="Propertyvalue2" class="form-control"
                      id="Propertyvalue2" aria-describedby="emailHelp" placeholder="Enter property code"
                      [(ngModel)]="integrationsetting.propertyvalue2">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col">
                    <p class="mb-0">Property Key 3</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="Propertyfield3" class="form-control"
                      id="Propertyfield3" aria-describedby="emailHelp" placeholder="Enter property name"
                      [(ngModel)]="integrationsetting.propertyfield3">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                  <div class="form-group col">
                    <p class="mb-0">Property Value 3</p>
                    <input (keyup)="saveIntegrationsettings()" type="string" name="Propertyvalue3" class="form-control"
                      id="Propertyvalue3" aria-describedby="emailHelp" placeholder="Enter property code"
                      [(ngModel)]="integrationsetting.propertyvalue3">
                    <small id="emailHelp" class="form-text text-muted">{{editstate}}</small>
                  </div>
                </div>
                <div class="alert alert-warning" role="alert">
                  <p class="mb-0"><b>IMPORTANT:</b> Changes are only saved when you click <b>Save settings</b>.</p>
                </div>
              </form>
            </div>
          </div>
        </div><!---
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Collapsible Group Item #2
                </button>
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Collapsible Group Item #3
                </button>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </div>
          </div>-->
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h5 class="mb-0">
              <button class="btn" data-toggle="collapse" data-target="#collapseTwo">
                <p class="btn-text">{{ 'orgaccount.emaildelivery' | trans }}</p>
              </button>
            </h5>
          </div>
          <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group">
                <p class="mb-0">{{ 'orgaccount.emaildelivery' | trans }}</p>
                <select (change)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.emailsetting" class="form-control" id="emaildelivery">
                  <option selected hidden>{{ 'orgaccount.choosedelivery' | trans }}</option>
                  <option value="Standard(SMTP)">Standard(SMTP)</option>
                  <option value="SMTP2Go">SMTP2Go</option>
                </select>
              </div>
              <div *ngIf="integrationsetting.emailsetting === 'Standard(SMTP)'" class="form-group">
                <p class="mb-0">SMTP Server URL</p>
                <input (keyup)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.smtpserverurl" type="text" class="form-control" name="smtpserverurl" id="smtpserverurl"
                  placeholder="smtp://mail.example.com:587">
              </div>
              <div *ngIf="integrationsetting.emailsetting === 'Standard(SMTP)'" class="form-group">
                <p class="mb-0">SMTP Username</p>
                <input (keyup)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.smtpusername" type="text" class="form-control" name="smtpusername" id="smtpusername"
                  placeholder="username">
              </div>
              <div *ngIf="integrationsetting.emailsetting === 'Standard(SMTP)'" class="form-group">
                <p class="mb-0">SMTP Password</p>
                <input (keyup)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.smtppassword" type="password" class="form-control" name="smtppassword" id="smtppassword"
                  placeholder="password">
              </div>
              <div *ngIf="integrationsetting.emailsetting === 'SMTP2Go'" class="form-group">
                <p class="mb-0">{{ 'orgaccount.apikey' | trans }}</p>
                <input (keyup)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.smtp2goapikey" type="text" class="form-control" name="emaildeliveryapi" id="emaildeliveryapi"
                  placeholder="{{ 'orgaccount.apihere' | trans }}">
              </div>
              <div *ngIf="integrationsetting.emailsetting === 'SMTP2Go' || integrationsetting.emailsetting === 'Standard(SMTP)'" class="form-group">
                <p class="mb-0">{{ 'orgaccount.fromaddress' | trans }}</p>
                <input (keyup)="saveIntegrationsettings()" [(ngModel)]="integrationsetting.fromaddress" type="text" class="form-control" name="emaildeliveryfrom" id="emaildeliveryfrom"
                  placeholder="{{ 'orgaccount.fromaddresshere' | trans }}">
              </div>
              <div class="alert alert-warning" role="alert">
                <p class="mb-0"><b>IMPORTANT:</b> Changes are only saved when you click <b>Save settings</b>.</p>
              </div>
              <div *ngIf="validationErrors.length > 0" class="alert alert-danger" role="alert">
                <p class="mb-1"><b>Please fix the following before saving:</b></p>
                <ul class="mb-0 pl-3">
                  <li *ngFor="let error of validationErrors">{{ error }}</li>
                </ul>
              </div>

              <div *ngIf="canShowEmailTestSection()" class="test-email-section">
                <h6 class="mb-2">Test Email</h6>
                <p class="mb-2 text-muted">A preview of the message that will be sent to your logged-in email address.</p>

                <div class="test-email-preview">
                  <p class="mb-1"><b>To:</b> {{ testEmailPreview.to || 'Not available in session' }}</p>
                  <p class="mb-1"><b>Subject:</b> {{ testEmailPreview.subject }}</p>
                  <p class="mb-2"><b>Body preview:</b></p>
                  <pre class="mb-0">{{ testEmailPreview.bodyText }}</pre>
                </div>

                <div class="mt-2 d-flex align-items-center">
                  <button type="button" class="btn cursor-pointer"
                    (click)="sendTestEmail()"
                    [disabled]="!canSendTestEmail()">
                    <p class="mb-0 btn-text cursor-pointer">{{ isSendingTestEmail ? 'Sending...' : 'Send test email' }}</p>
                  </button>
                  <small class="ml-2 text-muted" *ngIf="hasUnsavedChanges">Save settings first to test the selected delivery method.</small>
                </div>

                <div *ngIf="testEmailStatus" class="alert alert-success mt-2 mb-0" role="alert">
                  {{ testEmailStatus }}
                </div>
                <div *ngIf="testEmailError" class="alert alert-danger mt-2 mb-0" role="alert">
                  {{ testEmailError }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <small class="mr-auto text-muted">{{editstate}}</small>
      <button type="button" class="btn cursor-pointer"
        (click)="persistIntegrationsettings()"
        [disabled]="isSaving || !hasUnsavedChanges || validationErrors.length > 0">
        <p class="mb-0 btn-text cursor-pointer">{{ isSaving ? 'Saving...' : 'Save settings' }}</p>
      </button>
    </div>
  </div>
</div>